import gql from 'graphql-tag';


// Calculo de la deuda total. 
export const QUERY_TOTAL_DEUDA = gql(`
    query totalDeuda($filter: [String], $page: Int!, $size: Int!, $fieldName: String!){
        totalDeuda(criteria: { filter: $filter, page: $page, size: $size}, fieldName: $fieldName) 
    }`)


export const QUERY_CONTEO_IMPAGOS = gql(`
    query conteos($filter: [String], $page: Int!, $size: Int!){
       conteoImpagos(criteria: { filter: $filter, page: $page, size: $size})
    }`)    

export const ADD_IMPAGO = gql(`
    mutation addImpago($importe:Float,$fecha: Long, $fechaVencimiento: Long, $operacionUuid:String, $referenciaCliente:String, $uuidUsuario:String){
        addImpago(importe: $importe, fecha: $fecha, fechaVencimiento: $fechaVencimiento, operacionUuid: $operacionUuid, referenciaCliente: $referenciaCliente, uuidUsuario: $uuidUsuario){
            request{clienteIdLegal}
            reclamacion {token}
            impagos {uuid}
        }
    }
`);